import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { ReportsFilterBar } from './ReportsFilterBar';
import { ChevronRight, Home } from 'lucide-react';

export const ReportsContainer = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    // Basic Breadcrumb Map
    const breadcrumbMap = {
        'reports': 'Reportes',
        'executive': 'Resumen Ejecutivo',
        'portfolio': 'Portafolio',
        'monitoring': 'Monitoreo & Gaceta',
        'procedures': 'Procedimientos',
        'brand-protection': 'Brand Protection',
        'client': 'Generador de Reportes'
    };

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            {/* Dynamic Header / Breadcrumbs */}
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 text-sm text-gray-500">
                    <Link to="/reports" className="hover:text-indigo-600 flex items-center gap-1">
                        <Home className="h-4 w-4" />
                        Reportes
                    </Link>
                    {pathSegments.length > 1 && (
                        <>
                            <ChevronRight className="h-4 w-4" />
                            <span className="font-semibold text-gray-900">
                                {breadcrumbMap[pathSegments[1]] || pathSegments[1]}
                            </span>
                        </>
                    )}
                </div>
                <div>
                    {/* Possible Action Buttons specific to the view could go here via Portal or Context */}
                </div>
            </div>

            <div className="space-y-6">
                {/* Global Filter Bar */}
                <ReportsFilterBar />

                {/* Content */}
                <div className="min-h-[600px]">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};
